import { useAuth } from "../context/AuthContext";
import { FiUser, FiMail, FiCalendar } from "react-icons/fi";

export default function Profile() {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="min-h-screen bg-dark-900 pt-20 pb-16">
      <div className="max-w-2xl mx-auto px-5 md:px-10">
        <h1 className="text-2xl font-bold text-white mb-8">My Profile</h1>

        <div className="bg-dark-700 border border-dark-400 rounded-2xl p-6 md:p-8">
          {/* Avatar */}
          <div className="flex items-center gap-5 mb-8">
            <div className="w-20 h-20 rounded-full bg-primary/20 flex items-center justify-center">
              <FiUser size={32} className="text-primary" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-white">{user.name}</h2>
              <p className="text-sm text-gray-500">{user.email}</p>
            </div>
          </div>

          {/* Details */}
          <div className="space-y-5">
            <div>
              <label className="flex items-center gap-2 text-sm font-medium text-gray-400 mb-1.5">
                <FiUser size={14} /> Full Name
              </label>
              <p className="px-4 py-3 bg-dark-600 border border-dark-400 rounded-lg text-white text-sm">
                {user.name}
              </p>
            </div>

            <div>
              <label className="flex items-center gap-2 text-sm font-medium text-gray-400 mb-1.5">
                <FiMail size={14} /> Email Address
              </label>
              <p className="px-4 py-3 bg-dark-600 border border-dark-400 rounded-lg text-gray-400 text-sm">
                {user.email}
              </p>
            </div>

            {user.created_at && (
              <div>
                <label className="flex items-center gap-2 text-sm font-medium text-gray-400 mb-1.5">
                  <FiCalendar size={14} /> Member Since
                </label>
                <p className="px-4 py-3 bg-dark-600 border border-dark-400 rounded-lg text-gray-400 text-sm">
                  {new Date(user.created_at).toLocaleDateString("en-US", {
                    year: "numeric", month: "long", day: "numeric",
                  })}
                </p>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}
